import ValueX from '../types/ValueX';

export default class ReportedX extends ValueX {
    static __className = 'ReportedX';

    constructor(constructJson) {
        super(constructJson, 'medication', 'ReportedX');
    }
}
